import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import moment from 'moment';
import {
  Layout,
  Row,
  Col,
  Input,
  DatePicker,
  Typography,
  Button,
  Badge,
  Tag,
} from 'antd';
import { withRouter } from 'react-router-dom';
import 'react-table/react-table.css';
import { debounce, writeCsvFile } from '../../utils';
import {
  setCommentOpened,
  setPoOpenChat,
  setRequestFilters,
  resetRequestFilters,
} from '../../actions';
import SuggestionsDialog from '../../components/suggestions/SuggestionsDialog';
import {
  getPendingOnboardingRequests,
  getPendingOnboardingRequestsCount,
  claimOnboarding,
} from '../../services/api/pending-onboarding';

const { Text } = Typography;

const getDefaultState = () => ({
  loading: true,
  filtered: [],
  pendingRequests: [],
  sorted: [],
  pageSize: 25,
  page: 0,
  pages: -1,
  search: '',
  reqStartDate: null,
  reqEndDate: null,
  aptStartDate: null,
  aptEndDate: null,
  totalRecords: 0,
  suggestions: false,
  suggestionsDetails: null,
});

class NewPendingOnboardingTable extends Component {
  /* eslint-disable react/no-direct-mutation-state */
  constructor(props) {
    super(props);
    this.state = getDefaultState();
    // setting the default filters and sorting
    this.state.filtered = this.props.activeFilters;
    this.state.sorted = this.props.activeSorting;
    this.filtering = true;
    this.dateRefs = {
      aptStartDate: React.createRef(),
      aptEndDate: React.createRef(),
      reqStartDate: React.createRef(),
      reqEndDate: React.createRef(),
    };
    // setting default values for search and date filters
    if (this.props.activeFilters.length) {
      // iterating
      this.props.activeFilters.forEach((f) => {
        // search
        if (f.id === 'search') {
          this.state.search = f.value;
        }
        // request dates
        if (f.id === 'reqStartDate') {
          let formattedDate = moment(f.value * 1000);
          console.log(formattedDate, 'reqdate');
          this.state.reqStartDate = formattedDate;
        }
        if (f.id === 'reqEndDate') {
          let formattedDate = moment(f.value * 1000);
          this.state.reqEndDate = formattedDate;
        }
        // appointment dates
        if (f.id === 'aptStartDate') {
          let formattedDate = moment(f.value * 1000);
          this.state.aptStartDate = formattedDate;
        }
        if (f.id === 'aptEndDate') {
          let formattedDate = moment(f.value * 1000);
          this.state.aptEndDate = formattedDate;
        }
      });
    }
    // setting default page and page size
    if (this.props.activePage) {
      this.state.page = this.props.activePage;
    }
    if (this.props.activePageSize) {
      this.state.pageSize = this.props.activePageSize;
    }

    this.fetchDataWithDebounce = debounce(this.fetchData, 300);
  }
  /* eslint-enable */

  resetFilters = (event) => {
    event.preventDefault();
    console.log({ ref: this.dateRefs.reqStartDate });
    // this.dateRefs.reqStartDate.current.picker.;
    this.setState(getDefaultState());
    this.dateRefs.aptStartDate.current.value = '';
    this.dateRefs.aptEndDate.current.value = '';
    this.dateRefs.reqStartDate.current.value = '';
    this.dateRefs.reqEndDate.current.value = '';
    // reset filters in global state
    this.props.dispatch(resetRequestFilters());
  };

  getUnreadCount = (requestId) => {
    const data = this.props.count;
    if (requestId in data) {
      console.log('Unread count', requestId, data[requestId].messageCount);
      return data[requestId].messageCount;
    }
    return 0;
  };

  openSuggestions = (details) => {
    console.log('Open Suggestions from request', details);
    this.setState({
      suggestions: true,
      suggestionsDetails: details,
    });
  };

  closeSuggestions = () => {
    console.log('Close Suggestions from request');
    this.setState({
      suggestions: false,
      suggestionsDetails: null,
    });
  };

  onSearch = (e) => {
    console.log('Start date changed', e.target.value);
    this.setState({ search: e.target.value });
    this.updateStateFilters('search', e.target.value);
  };

  onReqStartDateChanged = (date, dateString) => {
    console.log('Start date changed', dateString);
    this.setState({ reqStartDate: date });
    const timestamp = moment(dateString, 'YYYY-MM-DD').valueOf() / 1000;

    if (date) {
      this.updateStateFilters('reqStartDate', timestamp);
    } else {
      this.updateStateFilters('reqStartDate', null);
    }
  };

  onReqEndDateChanged = (date, dateString) => {
    console.log('Start date changed', dateString);
    this.setState({ reqEndDate: date });
    const timestamp = moment(dateString, 'YYYY-MM-DD').valueOf() / 1000;

    if (date) {
      this.updateStateFilters('reqEndDate', timestamp);
    } else {
      this.updateStateFilters('reqEndDate', null);
    }
  };

  onAptStartDateChanged = (date, dateString) => {
    console.log('Start date changed', { date, dateString });
    this.setState({ aptStartDate: date });
    const timestamp = moment(dateString, 'YYYY-MM-DD').valueOf() / 1000;
    if (date) {
      this.updateStateFilters('aptStartDate', timestamp);
    } else {
      this.updateStateFilters('aptStartDate', null);
    }
  };

  onAptEndDateChanged = (date, dateString) => {
    console.log('end date changed', { date, dateString });
    this.setState({ aptEndDate: date });
    const timestamp = moment(dateString, 'YYYY-MM-DD').valueOf() / 1000;
    if (date) {
      this.updateStateFilters('aptEndDate', timestamp);
    } else {
      this.updateStateFilters('aptEndDate', null);
    }
  };

  updateStateFilters = (id, value) => {
    console.log('Update all filters in state', id, value);
    const filter = this.state.filtered.find((f) => f.id === id);
    if (filter) {
      filter.value = value;
    } else {
      this.state.filtered.push({ id, value });
    }
    this.setState({
      filtered: Array.from(this.state.filtered),
    });
  };

  onFilteredChange = (e) => {
    console.log('On filterd changed', e);
    this.setState({ filtered: e });
    this.filtering = true;
  };

  fetchStrategy = (state) => {
    // if (this.filtering) {
    //     return this.fetchDataWithDebounce();
    // } else {
    //     return this.fetchData();
    // }
    return this.fetchDataWithDebounce();
  };

  applyFilters = () => {
    console.log('Fetch data called', this.state.filtered);
    console.log('Sorting called', this.state.sorted);
    // show the loading overlay
    this.setState({ loading: true });
    this.filtering = false;

    const appliedFilters = {};

    this.state.filtered.forEach(
      (filter) => (appliedFilters[filter.id] = filter.value)
    );

    appliedFilters.rowsPerPage = this.state.pageSize;
    appliedFilters.page = this.state.page + 1;
    /*
     *
     * Storing the filters in redux
     *
     * */
    this.props.dispatch(
      setRequestFilters(
        this.state.filtered,
        this.state.sorted,
        this.state.page,
        this.state.pageSize
      )
    );

    return { appliedFilters, sorted: this.state.sorted };
  };

  fetchData = (downloadCsv) => {
    const { appliedFilters, sorted } = this.applyFilters();
    if (downloadCsv) {
      appliedFilters.page = 1;
      appliedFilters.rowsPerPage = 10000;
    }

    getPendingOnboardingRequests(appliedFilters, sorted)
      .then((response) => {
        console.log(
          response.body.data.totalRows % appliedFilters.rowsPerPage,
          'This'
        );
        if (!downloadCsv) {
          this.setState({
            pendingRequests: response.body.data.result,
            loading: false,
          });
        } else {
          writeCsvFile(response.body.data.result);
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.error(err, 'Error in get pendingRequests API');
      });

    getPendingOnboardingRequestsCount(appliedFilters, sorted)
      .then((response) => {
        console.log(
          response.body.data.totalRows % appliedFilters.rowsPerPage,
          'This'
        );

        const pages =
          response.body.data.totalRows % appliedFilters.rowsPerPage === 0
            ? parseInt(
              response.body.data.totalRows / appliedFilters.rowsPerPage
            )
            : parseInt(
              response.body.data.totalRows / appliedFilters.rowsPerPage
            ) + 1;

        this.setState({
          totalRecords: response.body.data.totalRows,
          pages,
        });
      })
      .catch((err) => {
        console.error(err, 'Error in get pendingRequests API');
      });
  };

  openDoctorProfile = (docId, requestId) => {
    this.props.history.push(`doctor-profile/${docId}`, {
      doctorId: docId,
    });
  };

  openComments = (row) => {
    console.log('Opened comment', row);
    this.props.dispatch(
      setCommentOpened({
        requestId: row.original.consultationId,
      })
    );
    // Don't know how this works
    this.props.dispatch(setPoOpenChat(false));
  };

  downloadCsv = (event) => {
    event.preventDefault();
    this.fetchData(true);
  };

  claimThisRequest = (request) => {
    console.log(request);

    claimOnboarding(request.original.consultationId)
      .then((result) => {
        if (result.message === 'success') {
          // alert('Onboarding process for this doctor assigned to you successfully!!!')
          // dispatch(setPoSelectedForClaim([]));
          // initiateFetchData()
          this.fetchData();
        } else {
          alert('unable to claim this request');
        }
      })
      .catch((err) => {
        console.log(err);
        alert('Error in claiming request');
      });
  };

  getColumns = () => [
    {
      Header: 'Pending Onboardings',
      columns: [
        {
          Header: 'RequestId',
          accessor: 'consultationId',
          filterable: true,
          Filter: ({ filter, onChange }) => {
            return (
              <Input
                placeholder="Request Id"
                value={filter ? filter.value : ''}
                onChange={(event) => onChange(event.target.value)}
              />
            );
          },
          Cell: (row) => (
            <div
              onClick={() =>
                this.openDoctorProfile(
                  row.original.doctorId,
                  row.original.consultationId
                )
              }
              style={{ cursor: 'pointer' }}
              className="bg-light"
            >
              <p className="mb-0" style={{ whiteSpace: 'initial' }}>
                Id: {row.original.consultationId}
              </p>
              <Tag
                className="badge badge-secondary"
                style={{ whiteSpace: 'initial', fontWeight: 'normal' }}
              >
                {row.original.requestDate}
              </Tag>
            </div>
          ),
          width: 100,
        },
        {
          Header: 'Doctor Info',
          accessor: 'doctorInfo',
          filterable: true,
          Filter: ({ filter, onChange }) => {
            return (
              <Input
                placeholder="Doctor/Hospital Info"
                value={filter ? filter.value : ''}
                onChange={(event) => onChange(event.target.value)}
              />
            );
          },
          Cell: (row) => (
            <div>
              {row.original.name}
              <br />
              <Tag
                className="badge badge-secondary"
                style={{ whiteSpace: 'initial', fontWeight: 'normal' }}
              >
                {row.original.practiceCenter}
              </Tag>
            </div>
          ),
          width: 150,
        },
        {
          Header: 'User Info',
          accessor: 'userName',
          filterable: true,
          Filter: ({ filter, onChange }) => {
            return (
              <Input
                placeholder="User Info"
                value={filter ? filter.value : ''}
                onChange={(event) => onChange(event.target.value)}
              />
            );
          },
          Cell: (row) => (
            <div>
              {row.original.userName}
              <br />
              <Tag
                className="badge badge-secondary"
                style={{ whiteSpace: 'initial', fontWeight: 'normal' }}
              >
                {row.original.userPhone}
              </Tag>
            </div>
          ),
          width: 150,
        },
        {
          Header: 'Sponsor',
          accessor: 'sponsorName',
          filterable: true,
          Filter: ({ filter, onChange }) => {
            return (
              <Input
                placeholder="Sponsor Name"
                value={filter ? filter.value : ''}
                onChange={(event) => onChange(event.target.value)}
              />
            );
          },
        },
        {
          Header: 'Relative Info',
          accessor: 'relativeName',
          Cell: (row) => (
            <span>
              {row.original.relativeName === null
                ? '- -'
                : row.original.relativeName}
            </span>
          ),
        },
        // {
        //   Header: 'TPA Name',
        //   accessor: 'tpaName',
        //   Cell: (row) => (
        //     <span>
        //       {row.original.tpaName === null ? '- -' : row.original.tpaName}
        //     </span>
        //   ),
        // },
        {
          Header: 'Appointment Date',
          accessor: 'appointmentDate',
          Cell: (row) => <span>{row.original.appointmentDate}</span>,
          width: 150,
        },
        {
          Header: 'Status',
          accessor: 'status',
          filterable: true,
          filterMethod: (filter, row) => {
            if (filter.value === 'all') {
              return true;
            }
            return row.status === filter.value;
          },
          Filter: ({ filter, onChange }) => {
            return (
              <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: '100%' }}
                value={filter ? filter.value : 'all'}
              >
                <option value="pending">Pending</option>
                <option value="not-live">Not Live</option>
                <option value="live">Live</option>
                <option value="all">All Onboardings</option>
              </select>
            );
          },
          Cell: (row) =>
            row.original.status === 'pending' ? (
              <Tag color="red">{row.original.status}</Tag>
            ) : row.original.status === 'live' ? (
              <Tag color="green">{row.original.status}</Tag>
            ) : (
              <Tag color="cyan">{row.original.status}</Tag>
            ),
        },
        {
          Header: 'Request Status',
          accessor: 'requestStatus',
          filterable: true,
          filterMethod: (filter, row) => {
            if (filter.value === 'all') {
              return true;
            }
            return row.status === filter.value;
          },
          Filter: ({ filter, onChange }) => {
            return (
              <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: '100%' }}
                value={filter ? filter.value : 'all'}
              >
                <option value="confirmed">Confirm Requests</option>
                <option value="awaiting">Awaiting Confirmation</option>
                <option value="cancelled">Cancelled Requests</option>
                <option value="all">All Requests</option>
              </select>
            );
          },
        },
        {
          Header: 'Assigned To',
          accessor: 'assignedTo',
          filterable: true,
          Filter: ({ filter, onChange }) => {
            return (
              <Input
                placeholder="Operator Name"
                value={filter ? filter.value : ''}
                onChange={(event) => onChange(event.target.value)}
              />
            );
          },
        },
        {
          Header: 'Visit Spoc',
          accessor: 'visitSpoc',
          filterable: true,
          Filter: ({ filter, onChange }) => {
            return (
              <Input
                placeholder="Spoc Name"
                value={filter ? filter.value : ''}
                onChange={(event) => onChange(event.target.value)}
              />
            );
          },
        },
        {
          Header: 'Ops Claimed User',
          accessor: 'opsClaimedUser',
          filterable: false,
        },
        {
          Header: 'Actions',
          accessor: 'relativeName',
          Cell: (row) => (
            <Col>
              <Button type="primary" onClick={() => this.claimThisRequest(row)}>
                Claim
              </Button>
              <br />
              <Button onClick={() => this.openComments(row)}>
                Comment
                <Badge
                  count={this.getUnreadCount(row.original.consultationId)}
                />
              </Button>
              <br />
              <Button onClick={() => this.openSuggestions(row.original)}>
                Suggest
              </Button>
            </Col>
          ),
        },
      ],
    },
  ];

  render() {
    console.log({ state: this.state, props: this.props });
    return (
      <Layout style={{ marginTop: 10 }}>
        <Row style={{ marginLeft: 10 }}>
          <Row gutter={[8, 8]} style={{ textAlign: 'center' }}>
            {/* <Col span={4}>
              <Text htmlFor="inputEndDate">Filter by Doctor/Hospital</Text>
              <br />
              <Input
                placeholder="Filter by Doctor/Hospital"
                onChange={this.onSearch}
                value={this.state.search}
                style={{ width: '100%' }}
              />
            </Col> */}
            <Col span={6}>
              <Text htmlFor="inputStartDate">Request Start</Text>
              <br />
              <DatePicker
                ref={this.dateRefs.reqStartDate}
                type="date"
                className="form-control"
                id="inputStartDate"
                onChange={this.onReqStartDateChanged}
                value={this.state.reqStartDate}
              />
            </Col>

            <Col span={6}>
              <Text htmlFor="inputEndDate">Request End Date</Text>
              <br />
              <DatePicker
                ref={this.dateRefs.reqEndDate}
                type="date"
                className="form-control"
                id="inputEndDate"
                onChange={this.onReqEndDateChanged}
                value={this.state.reqEndDate}
              />
            </Col>
            <Col span={6}>
              <Text htmlFor="inputStartDate">Appointment Start Date</Text>
              <br />
              <DatePicker
                type="date"
                ref={this.dateRefs.aptStartDate}
                className="form-control"
                id="inputStartDate"
                onChange={this.onAptStartDateChanged}
                value={this.state.aptStartDate}
              />
            </Col>

            <Col span={6}>
              <Text htmlFor="inputEndDate">Appointment End Date</Text>
              <br />
              <DatePicker
                type="date"
                ref={this.dateRefs.aptEndDate}
                className="form-control"
                id="inputEndDate"
                onChange={this.onAptEndDateChanged}
                value={this.state.aptEndDate}
              />
            </Col>
          </Row>
        </Row>

        <Row style={{ marginTop: '8px', textAlign: 'center' }}>
          <Row gutter={[8, 8]}>
            <Col span={6} offset={6}>
              <Button type="" onClick={this.resetFilters}>
                Reset Filters
              </Button>
            </Col>

            <Col span={6}>
              <Button type="" onClick={this.downloadCsv}>
                Download CSV
              </Button>
            </Col>
          </Row>
        </Row>

        <Row type="flex" justify="center">
          <Col>
            <h3>
              <Tag color="purple" className="badge badge-info">
                Total: {this.state.totalRecords}
              </Tag>
            </h3>
          </Col>
        </Row>

        {this.state.suggestions && (
          <SuggestionsDialog
            suggestionsDetails={this.state.suggestionsDetails}
            isOpen={this.state.suggestions}
            closeSuggestions={this.closeSuggestions}
            verticals={this.props.verticals}
          />
        )}

        <Row>
          <ReactTable
            keyField="consultationId"
            data={this.state.pendingRequests}
            columns={this.getColumns()}
            defaultPageSize={25}
            pageSize={this.state.pageSize}
            className="-striped -highlight"
            loading={this.state.loading}
            filtered={this.state.filtered}
            sorted={this.state.sorted}
            page={this.state.page}
            pages={this.state.pages}
            manual
            style={{ flex: 1, color: 'black' }}
            onFetchData={this.fetchStrategy}
            onFilteredChange={this.onFilteredChange}
            onPageSizeChange={(pageSize) => this.setState({ pageSize })}
            onPageChange={(page) => this.setState({ page })}
            onSortedChange={(sorted) => this.setState({ sorted })}
            showPaginationTop
            showPaginationBottom
          />
        </Row>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    count: state.notifications.lastReadOfAChat,
    activeFilters: state.pendingRequests.filters,
    activeSorting: state.pendingRequests.sorting,
    activePage: state.pendingRequests.page,
    activePageSize: state.pendingRequests.pageSize,
    verticals: state.info.verticals,
  };
}

export default connect(mapStateToProps)(withRouter(NewPendingOnboardingTable));
